import type { QuestionViewProps } from "../contracts";
import { GridChoiceMatrix } from "../grid/GridChoiceMatrix";
import type {
  GridMultiSelectDefinition,
  GridMultiSelectDraft,
  GridMultiSelectEvent,
} from "./core";

type GridMultiSelectViewProps = QuestionViewProps<
  GridMultiSelectDefinition,
  GridMultiSelectDraft,
  GridMultiSelectEvent
>;

const GridMultiSelectView = (props: GridMultiSelectViewProps) => {
  const options = props.definition.dontKnow
    ? [
        ...props.definition.options,
        {
          id: props.definition.dontKnow.value,
          label: props.definition.dontKnow.label,
          disabled: false,
          interactionDisabled: !props.controls.canSubmit,
        },
      ]
    : props.definition.options;
  return (
    <>
      <GridChoiceMatrix
        rows={props.definition.rows.map((row) => ({
          ...row,
          label: props.draft.specifiedRows?.[row.id] || row.label,
        }))}
        options={options}
        rowGroups={props.definition.rowGroups}
        optionGroups={props.definition.optionGroups}
        arrangement={props.display.arrangement}
        mode={props.display.view === "checkbox" ? "checkbox" : "button"}
        isSelected={(rowId, optionId) =>
          Boolean(props.draft.selectedByRow[rowId]?.includes(optionId))
        }
        onSelect={(rowId, optionId) => {
          const option = props.definition.options.find(
            (item) => item.id === optionId,
          );
          if (option?.customPrompt !== undefined) {
            props.controls.specify?.open({
              kind: "option-answer",
              rowId,
              optionId: option.id,
            });
          } else props.dispatch({ type: "toggle", rowId, optionId });
        }}
        specify={props.controls.specify}
        testId="grid-multi-select-view"
      />
    </>
  );
};

export const GridMultiSelectButtonsView = GridMultiSelectView;
export const GridMultiSelectCheckboxView = GridMultiSelectView;
